<template>
  <v-card id="sea-legend">
    <div class="text-center bgGrey">
      <span class="font-weight-bold title text-body-1 text-lg-h6"
        >Legenda:</span
      >
    </div>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: "sea-legend",
};
</script>
